var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 10.9092L13.334 14.6668H2.33398L4.72745 10.9092",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 10.9092L13.334 14.6668H2.33398L4.72745 10.9092H12.0002Z",
    stroke: "#7B7B7B",
    strokeWidth: 1.33,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00033 11L2.00033 1.33337C2.00033 1.33337 5.50033 2.00004 5.50033 3.33337C5.50033 4.16671 4.16699 4.66671 4.66699 5.16671C5.16699 5.66671 7.00033 6.16671 7.00033 7.50004C7.00033 8.33337 6.45366 8.95337 7.00033 9.50004C7.50033 10 8.00033 9.73804 8.83366 9.50004C9.76699 9.23337 11.667 9.00004 12.3337 9.16671C13.0003 9.33337 13.667 9.66671 13.667 10.6667C13.667 11.2167 13.3337 11.8334 12.5003 12C11.667 12.1667 10.667 11.3334 9.33366 11.3334C8.00033 11.3334 6.33366 12.3334 5.33366 12.3334C4.33366 12.3334 4.00033 11 4.00033 11Z",
    fill: "#EBEBEB",
    stroke: "#7B7B7B",
    strokeWidth: 1.33,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeat);
export default __webpack_public_path__ + "static/media/icon-seat.8a63a2284c29826c71d9cdd224ff6ce6.svg";
export { ForwardRef as ReactComponent };